import { Capacitor } from '@capacitor/core'
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'
import { FilePicker } from '@capawesome/capacitor-file-picker'

function blobToFile(blob, name, mimeType) {
  return new File([blob], name || 'archivo', {
    type: mimeType || blob.type || 'application/octet-stream'
  })
}

async function pickedToFile(picked) {
  if (!picked) return null

  if (picked.blob) {
    return blobToFile(picked.blob, picked.name, picked.mimeType)
  }

  if (picked.path) {
    const webPath = Capacitor.convertFileSrc(picked.path)
    const res = await fetch(webPath)
    if (!res.ok) {
      throw new Error('No se pudo leer el archivo seleccionado')
    }
    const blob = await res.blob()
    return blobToFile(blob, picked.name, picked.mimeType)
  }

  if (picked.data) {
    const binary = atob(picked.data)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i)
    }
    const blob = new Blob([bytes], { type: picked.mimeType || 'application/octet-stream' })
    return blobToFile(blob, picked.name, picked.mimeType)
  }

  return null
}

/**
 * Selector puntual de una imagen (Photo Picker / ACTION_PICK).
 * En Android nativo no se usa @capacitor/camera: la v5 pide READ_MEDIA_IMAGES
 * en runtime y Play Console lo rechaza. FilePicker.pickImages() abre el mismo
 * selector del sistema sin acceso amplio a la galería.
 */
export async function seleccionarImagen() {
  if (Capacitor.isNativePlatform()) {
    const result = await FilePicker.pickImages({ multiple: false })
    return pickedToFile(result.files && result.files[0])
  }

  const photo = await Camera.getPhoto({
    source: CameraSource.Photos,
    resultType: CameraResultType.Uri,
    quality: 90
  })
  const res = await fetch(photo.webPath)
  const blob = await res.blob()
  const ext = (blob.type && blob.type.split('/')[1]) || 'jpeg'
  return blobToFile(blob, `imagen.${ext}`, blob.type)
}

/**
 * Selector puntual de un video (ACTION_PICK video/*).
 * pickVideos solo existe en Android/iOS; en web se usa pickFiles.
 */
export async function seleccionarVideo() {
  const result = Capacitor.isNativePlatform()
    ? await FilePicker.pickVideos({ multiple: false })
    : await FilePicker.pickFiles({ types: ['video/*'], multiple: false })

  return pickedToFile(result.files && result.files[0])
}

export function seleccionCancelada(error) {
  const msg = (error && (error.message || error)) + ''
  return /cancel/i.test(msg)
}
